<template>
  <mu-dialog @close="close" dialogClass="report-modal" id="report-modal" :open="open" @click="close">
    <h3 class="heading">Reporting a post</h3>
    <p>Please choose a reason for reporting this post</p>
    <div class="radio" v-for="reason, index in reasons" :key="`reason-${index}`">
      <mu-radio name="group" :label="reason.reason" v-model="chosen_reason" :nativeValue="`${reason.id}`"/>
    </div>
    <mu-flat-button class="action-btn" slot="actions" @click="close" label="Cancel"/>
    <mu-flat-button class="action-btn" slot="actions" @click="submit" label="Okay" primary/>
  </mu-dialog>
</template>

<script>

  import ReportingApi from "../../api/Reporting";


  export default {
    props: {
      open: {
        type: Boolean,
        default: false,
      },
      type: {
        type: String,
        required: true,
      },
      type_id: {
        type: Number,
        required: true,
      }
    },
    name: "report-modal",
    data() {
      return {
        reasons: {},
        chosen_reason: null
      }
    },
    methods: {
      close() {
        let self = this;
        self.$emit('onClose', false);
      },
      loadReasons() {
        let self = this;

        if (self.$store.state.reportingReasons.length === 0) {
          ReportingApi.getReasons().then((response) => {
            self.reasons = response.data;
            self.$store.commit('setReportingReasons', self.reasons)
          });
        }
        else {
          self.reasons = self.$store.state.reportingReasons;
        }
      },
      submit() {
        let self = this;
        ReportingApi.postReport({
          type_id: self.type_id,
          type: self.type,
          reason_id: parseInt(self.chosen_reason)
        }).then((response) => {
          let message = "";
          if (!response.data.error) {
            message = "Content reported. Thanks";
            self.$emit('onComplete');
            self.chosen_reason = null;
          } else {
            message = response.data.message;
          }
          self.$toastr.success(message);
        }).catch((error) => {
          if (error.response.data) {
            self.$toastr.error(error.response.data.message);
          }
        });

        self.close();
      }
    },
    mounted() {
      let self = this;
      self.loadReasons();
    }
  }

</script>
<style lang="less">
  @import "./Reporting.less";
</style>



// WEBPACK FOOTER //
// Reporting.vue?61986234